import { useContext } from "react";
import OrganizationContext from "../context/organization-context";
import GroupContext from "../context/group-context";
import ToastContext from "context/toast-context";
import ScreenSizeContext from "context/screen-size-context";
import EnvironmentContext from "context/environment-context";

export function useAppContext() {
  const environment = useContext(EnvironmentContext);
  const organization = useContext(OrganizationContext);
  const group = useContext(GroupContext);
  const toast = useContext(ToastContext);
  const screenSize = useContext(ScreenSizeContext);

  return {
    environment,
    organization,
    group,
    toast,
    screenSize,
  };
}
